<div class="px-4 sm:px-6 lg:px-8">
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="text-base font-semibold leading-6 text-gray-900">Listado de usuarios</h1>
      <p class="mt-2 text-sm text-gray-700">
        Estás visualizando todos los <strong class="font-semibold text-gray-900">usuarios</strong>.
      </p>
    </div>
    <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
      <!-- <button routerLink="create/new" type="button" class="block rounded-md primary-button px-3 py-2 text-center text-sm font-semibold text-white shadow-sm">
        Crea un nuevo usuario
      </button> -->
    </div>
  </div>
  <div class="-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">
    <table class="min-w-full divide-y divide-gray-300">
      <thead>
        <tr>
          <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Usuario</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Rol</th>
          <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
            <span class="sr-only">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td class="relative py-4 pl-4 pr-3 text-sm sm:pl-6">
            <div class="font-medium text-gray-900">{{user.email.split('@')[0]}}</div>
            <div class="mt-1 flex flex-col text-gray-500 sm:block xl:hidden">
              <span>{{ translateService.translateUserRole(user.role) }}</span>
            </div>
          </td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{translateService.translateUserRole(user.role)}}</td>
          <td class="relative grid grid-cols-2 gap-2 py-3.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
            <button (click)="openUpdateUserPasswordModal(user)" type="button" class="inline-flex justify-center items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
              Modificar contraseña
            </button>

            <button (click)="openDeleteModal(user)" type="button" class="inline-flex justify-center items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
              Eliminar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<!-- 

  Delete Modal
  
-->
<div *ngIf="delete_modal" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
        <div>
          <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">
              Eliminar usuario {{delete_user.email.split('@')[0]}}
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                ¿Estás seguro que quieres eliminar al usuario {{delete_user.email.split('@')[0]}}?
                <br>
                <span class="italic underline">Esta acción no se puede deshacer.</span>
              </p>
            </div>
          </div>

          <fieldset class="mt-3 flex justify-center">
            <legend class="sr-only">Notifications</legend>
            <div class="space-y-5">
              <div class="relative flex items-start">
                <div class="flex h-6 items-center">
                  <input [(ngModel)]="modal_delete_checkbox" id="delete_modal_checkbox" aria-describedby="delete_modal_checkbox" name="delete_modal_checkbox" type="checkbox" class="h-4 w-4 rounded border-gray-300 primary-text-color focus:primary-ring-color">
                </div>
                <div class="ml-3 text-sm leading-6">
                  <label for="comments" class="font-medium text-gray-900">Confirmo que quiero eliminar al usuario {{delete_user.email.split('@')[0]}}</label>
                  <!-- <span id="comments-description" class="text-gray-500">Identificado como {{firebaseService.user.email}}</span> -->
                </div>
              </div>
            </div>
          </fieldset>

        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense {{ modal_delete_checkbox ? 'sm:grid-cols-2' : '' }} sm:gap-3">
          <button *ngIf="modal_delete_checkbox" (click)="deleteUser()" type="button" class="primary-button inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:col-start-2">
            Confirmar
          </button>
          <button (click)="closeDeleteModal()" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<!--

  Update User Password Modal

-->


<div *ngIf="update_password_modal" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
        <div>
          <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">
              Cambiado la contraseña al usuario {{delete_user.email.split('@')[0]}}
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                Estás a punto de cambiar la contraseña del usuario {{delete_user.email.split('@')[0]}}
                <br>
                <span class="italic underline">La contraseña ha de tener 8 caractéres o más.</span>
              </p>
            </div>
          </div>

          <input [(ngModel)]="update_user_password.password" type="password" name="password" id="password" placeholder="Nueva contraseña" class="mt-2 form-control block w-full rounded-xl border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none" />

        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense {{ modal_delete_checkbox ? 'sm:grid-cols-2' : '' }} sm:gap-3">
          <button *ngIf="update_user_password.password.length >= 6" (click)="updateUserPassword()" type="button" class="primary-button inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:col-start-2">
            Confirmar
          </button>
          <button (click)="closeUpdatePasswordModal()" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>